//
//
//
//

export default {
  name: "App",

  data: () => ({
    //
  })
};
